import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    profile: {},
    userId: '',
    routeInfo: {},
    orderId: '',
    accountOrderData: {},
    validateInfo: {},
    RecordInfo: null,
    reviewItem: null
  },
  mutations: {
    updateReviewItem (state, e) {
      state.reviewItem = e
    },
    updateRecordInfo (state, e) {
      state.RecordInfo = e
    },
    updateValidateInfo (state, e) {
      state.validateInfo[e.id] = e
    },
    updateLineProfile (state, profile) {
      state.profile = profile
    },
    updateLineUserId (state, userId) {
      state.userId = userId
    },
    updateRouteInfo (state, routeInfo) {
      state.routeInfo = routeInfo
    },
    updateOrderId (state, orderId) {
      state.orderId = orderId
    },
    updateAccountOrderData (state, accountOrderData) {
      state.accountOrderData = accountOrderData
    }
  },
  actions: {
    setReviewItem (context, e) {
      context.commit('updateReviewItem', e)
    },
    pushValidateInfo (context, item) {
      context.commit('updateValidateInfo', {
        id: item.id,
        top: item.top,
        checkValueIsValid: item.checkValueIsValid
      })
    },
    setRecordInfo (context, e) {
      context.commit('updateRecordInfo', e)
    },
    setLineProfile (context, profile) {
      context.commit('updateLineProfile', profile)
    },
    setLineUserId (context, userId) {
      context.commit('updateLineUserId', userId)
    },
    setRouteInfo (context, routeInfo) {
      context.commit('updateRouteInfo', routeInfo)
    },
    setOrderId (context, orderId) {
      context.commit('updateOrderId', orderId)
    },
    setAccountOrderData (context, accountOrderData) {
      context.commit('updateAccountOrderData', accountOrderData)
    }
  },
  modules: {
  },
  getters: {
    getProfile: state => {
      return state.profile
    },
    getUserId: state => {
      return state.userId
    },
    getRouteInfo: state => {
      return state.routeInfo
    },
    getOrderId: state => {
      return state.orderId
    },
    getAccountOrderData: state => {
      return state.accountOrderData
    }
  }
})
